import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `EmailVaultControllerStateProvider` not mounted on RN.
export default function useEmailVaultControllerState(): any {
  const { state } = useController('EmailVaultController' as any)
  return state as any
}
